import React from 'react';
import { Layout, Dropdown, Menu, message } from 'antd';
import mElectronApi from '../../util/electron';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { hasDarwin, showErrorMessage } from '../../util/index';
import Emitter from '../../services/emitter';
import CONSTANT from '../../constant';
import ProjectApi from '../../services/api/project';
import History from '../../util/history';
import LanguageAction from '../../reducers/language/action';
import MenuAction from '../../reducers/menu/action';
import Subscribe from '../../util/subscribe';
import { isInternational } from '../../util/env';

const MenuLanguageKey = 'MENU.LANGUAGE';
const MenuOpenKey = 'MENU.FILE.OPEN.WEB';
const MenuSaveKey = 'MENU.FILE.SAVE.WEB';
const MenuSaveas = 'MENU.FILE.SAVEAS.WEB';
const MenuAdaptSaveKey = 'MENU.FILE.ADAPT.SAVE';
const MenuExportKey = 'MENU.FILE.EXPORT';
const MenuHlepGuideKey = 'MENU.HELP.GUIDE';
const MenuHlepAboutKey = 'MENU.HELP.ABOUT';
const MenuHlepFeedbackKey = 'MENU.HELP.FEEDBACK';

class MainDropdowns extends React.Component {

    constructor(props) {
        super(props);
        const obr = value => {
            console.log('订阅了是否有网络 ', value);
            this.networkStatus = value;
        };
        Subscribe.listen('network', obr);
    }

    disabled = data => {
        const { menu } = this.props;
        const { operate } = menu;
        if (_.has(data, 'operate') && _.has(operate, data.operate)) {
            return !operate[data.operate];
        }
        return false;
    }

    // 显示具体的菜单条目
    menuItem = data => {
        const { intlr, project } = this.props;
        const { isSelfProject } = project;
        const { menus } = data;
        const notShowSaveas = !isSelfProject && data.key === MenuSaveas;
        if (!_.isEmpty(menus)) {
            return (
                <Menu.SubMenu className="header-dropdown-menu" key={data.key} title={intlr.messages[data.key]}>
                    {menus.map(menu => this.menuItem(menu))}
                </Menu.SubMenu>
            );
        }

        // 加载第三方课堂的项目时，不显示保存菜单
        const onlyShowForMKProject = ['MENU.FILE.SAVE.WEB', 'MENU.FILE.SAVEAS.WEB', MenuAdaptSaveKey];
        if (project.isForThirdPlatform && onlyShowForMKProject.indexOf(data.key) !== -1) {
            return null;
        }

        // 非国际版本，隐藏提交项目到谷歌课堂
        const onlyShowInInternationalMenuItems = ['MENU.FILE.PUBLISH.TO'];
        if (!isInternational() && onlyShowInInternationalMenuItems.indexOf(data.key) !== -1) {
            return null;
        }
        return (
            <Menu.Item style={notShowSaveas ? {display: 'none'} : null} key={data.key}
                link={data.link}
                disabled={this.disabled(data)}>
                <span className="menu-label">{intlr.messages[data.key]}</span>
                {
                    mElectronApi.has('shortcutkey') && !_.isEmpty(data.shortcutKey) &&
                    <span className="menu-shortcut-key">
                        {
                            hasDarwin()
                                ? data.shortcutKey[1]
                                : data.shortcutKey[0]
                        }
                    </span>
                }
            </Menu.Item>
        );
    }

    updateMenus = (webMenus, isSelfProject) => {
        const dowithArr = (arr, key1, key2) => {
            return arr.map((l) => {
                if (l.key === key1) {
                    l.key = key2;
                }
                // if (l.key === MenuLanguageKey) {
                //     arr.splice(i, 1);
                // }
                return l;
            });
        };

        const options = {
            'isSelfProject': arr => dowithArr(arr, 'MENU.FILE.ADAPT.SAVE', 'MENU.FILE.SAVE.WEB'),
            'notSelfProject': arr => dowithArr(arr, 'MENU.FILE.SAVE.WEB', 'MENU.FILE.ADAPT.SAVE')
        };

        const type = isSelfProject ? 'isSelfProject' : 'notSelfProject';
        return options[type](webMenus);
    }

    mainMenu = () => {
        const { menu, project } = this.props;
        const { isSelfProject } = project;
        const { webMenus } = menu;

        return (
            <Menu className="header-dropdown-menu" subMenuOpenDelay={0.1} onClick={this.handleMenuClick}>
                {this.updateMenus(webMenus, isSelfProject).map(menu => this.menuItem(menu))}
            </Menu>
        );
    }

    showSaveErrorMessage = () => {
        const { intlr } = this.props;
        const leftCon = intlr.messages['MENU.FILE.UPLOAD.FAIL'];
        const rightCon = intlr.messages['BUTTON.CLOSE.TEXT'];
        const style = {
            div: {
                display: 'inline-block'
            },
            secSpan: {
                margin: '0 5px'
            },
            lastSpan: {
                cursor: 'pointer'
            }
        };
        const msgDiv = <div className="upload-file" style={style.div}>
            <span>{leftCon}</span>
            <span className="mid-part" style={style.secSpan}>|</span>
            <span onClick={() => message.destroy()} style={style.lastSpan}>{rightCon}</span>
        </div>;
        message.error(msgDiv, 0);
    }

    handleSaveListMenuClick = (callback) => {
        const { account, intlr, project } = this.props;
        const { showLoadingPage, saveStatus, name } = project;
        if (showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
            return;
        }
        callback = typeof callback === 'function' ? callback : undefined;
        const { isLogin } = account;
        const { isSelfProject, projectId } = project;
        if (this.networkStatus === 'offline') {
            this.showSaveErrorMessage();
            return;
        } else if (!isLogin) {
            History.replace('/login');
            return;
        }

        if (isSelfProject) {
            Emitter.emit('SaveProject', false, 'web', {name}, callback);
        } else {
            Emitter.emit('SaveProject', false, 'web', {name: `${name}-${intlr.messages['MENU.FILE.ADAPT']}`, isSelfProject: false, isShare: true, projectId: ProjectApi.getCorrectId(projectId)}, () => {
                History.replace('/');
            });
        }
    }

    handleMenuClick = async ({ key, item }) => {
        const { project } = this.props;
        const { saveStatus } = project;

        if (key && item) {
            const { change, visibleChange, account } = this.props;
            const { link } = item.props;
            const isOpenKey = key.indexOf(MenuOpenKey) === 0;
            const isSaveKey = key.indexOf(MenuSaveKey) === 0;
            const isSaveasKey = key.indexOf(MenuSaveas) === 0;
            const isAdaptSave = key.indexOf(MenuAdaptSaveKey) === 0;
            const isLanguageKey = key.indexOf(MenuLanguageKey) === 0;
            const isExportKey = key.indexOf(MenuExportKey) === 0;
            const isHlepGuideKey = key.indexOf(MenuHlepGuideKey) === 0;
            const isHlepAboutKey = key.indexOf(MenuHlepAboutKey) === 0;
            const isHlepFeedbackKey = key.indexOf(MenuHlepFeedbackKey) === 0;

            if (saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING && !isExportKey && !isHlepGuideKey && !isHlepAboutKey && !isHlepFeedbackKey) {
                return;
            }

            // 处理作品分享
            if(key === 'MENU.FILE.PUBLISH.TO') {
                if (!account.isLogin) {
                    History.replace('/login');
                    return;
                }
                const callback = function (projectId) {
                    History.replace('/help/shareprojectto');
                    ProjectApi.saveAsThirdPlatformProject(projectId);
                };
                Emitter.emit('SaveProject', false, 'web', {
                    name: project.name
                }, callback);
            }

            if ((isOpenKey || isSaveKey || isSaveasKey) && this.networkStatus === 'offline') {
                const msg = isOpenKey
                    ? 'MSG.99999'
                    : 'MENU.FILE.UPLOAD.FAIL';
                if (isOpenKey) {
                    showErrorMessage.bind(this)(msg);
                } else {
                    this.showSaveErrorMessage();
                }
            } else if ((isOpenKey || isSaveKey || isSaveasKey) && !account.isLogin) {
                History.replace('/login');
            } else if (isLanguageKey) {
                change(key.replace(MenuLanguageKey, ''));
            } else if (link) {
                History.push(link);
            } else if (isAdaptSave) {
                this.handleSaveListMenuClick();
            }else {
                Emitter.emit('ClickMenu', key);
            }
            visibleChange('main', false);
        }
        return true;
    }

    mainDropdown = () => {
        const { menu, visibleChange, project } = this.props;
        const { showLoadingPage } = project;
        return (
            <Layout.Header className="header">
                <Dropdown
                    disabled={showLoadingPage ? true : false}
                    trigger={['click']}
                    overlay={this.mainMenu()}
                    onVisibleChange={visible => visibleChange('main', visible)}>
                    <span id="mainMenuTrigger"
                        className={`menu-icon menu-trigger ${menu.main ? 'active' : ''}`}>
                        <span className="menu-bar"></span>
                        <span className="menu-bar menu-middle-bar"></span>
                        <span className="menu-bar"></span>
                    </span>
                </Dropdown>
            </Layout.Header>
        );
    }

    render() {
        return (
            <section className="header-cell main-menu-cell">
                {this.mainDropdown()}
            </section>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr,
    menu: state.menu,
    project: state.project,
    account: state.account,
});

const mapDispatchToProps = dispatch => ({
    change: lang => dispatch(LanguageAction.change(lang)),
    visibleChange: (type, visible) => dispatch(MenuAction.visibleChange(type, visible))
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(MainDropdowns));